/**
 * Páginas principales del encabezado. Las usan las pestañas (pantalla ancha) y la sección «Ir a» del
 * menú del avatar (celular), así ambas listas siguen los mismos permisos sin repetirse.
 * La web solo oculta: la API es quien exige el permiso de administración.
 */
import { useYo } from '../features/auth/sesion';
import type { NombreIcono } from './Icono';

export interface PaginaPrincipal {
  a: string;
  icono: NombreIcono;
  texto: string;
  /** Solo coincide con la ruta exacta (el tablero es `/`, que si no calzaría con todo). */
  fin?: boolean;
}

export function usePaginasPrincipales(): PaginaPrincipal[] {
  const yo = useYo();
  const paginas: PaginaPrincipal[] = [
    { a: '/', icono: 'tablero', texto: 'Tablero', fin: true },
    { a: '/docs', icono: 'doc', texto: 'Documentación' },
  ];
  if (yo.puedeAdministrar) {
    paginas.push(
      { a: '/personas', icono: 'personas', texto: 'Personas' },
      { a: '/configuracion', icono: 'ajustes', texto: 'Configuración' },
    );
  }
  return paginas;
}
